import LinkTiktok, { LinkTiktokProps as _LinkTiktokProps } from './LinkTiktok';

export { LinkTiktok };
export type LinkTiktokProps = _LinkTiktokProps;
